import { useEffect, useState, useCallback } from 'react';
import { Affix, Form } from 'antd';
import { Button, message } from 'antd';
import { useParams } from 'react-router-dom';

import AppHeader from 'components/AppHeader';
import promoCodeApis from 'api/promoCodeApis';
import PromoCodeForm from './components/form'
import { formDataWithImages } from 'helpers/formHelpers';
import moment from "moment";


export default function DetailPromoCodePage() {
  let { promoCodeId } = useParams();
  const [promoCode, setPromoCode] = useState({});
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const response = await promoCodeApis.detail(promoCodeId);

      if (response.code == 200) {
        const data = response.data;
        setPromoCode(data);
        form.setFieldsValue({
          ...data,
          expired_at: moment.unix(data.expired_at)
        });
      } else {
        message.error(response.message ?? 'Đã có lỗi');
      }
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const handleOnSubmit = async () => {
    setIsLoading(true);
    let data = form.getFieldsValue();
    console.log(data)
    data.expired_at = moment(data.expired_at, 'DD/MM/YYYY').format('DD/MM/YYYY');
    try {
      const res = await promoCodeApis.update(promoCode.id, data);
      if (res.code == 200) {
        message.success(res.message);
        // window.location.reload();
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error(error.message);
    }
    setIsLoading(false);
  };

  const validateData = () => {
    form
      .validateFields()
      .then(() => {
        handleOnSubmit();
      })
      .catch((info) => {
        const errorMsg = 'Validate Failed: ' + info.errorFields[0].errors[0];
        form.scrollToField(info.errorFields[0].name, {
          behavior: 'smooth',
          block: 'center'
        });
        message.error(errorMsg);
      });
  };
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle={`Cập nhật PromoCode (ID ${promoCode.id})`}
        pageHeaderExtras={[
          <Button type="primary" onClick={validateData} loading={isLoading}>
            Cập nhật
          </Button>
        ]}
      />

      <PromoCodeForm
        form={form}
        promoCode={promoCode}
      />

    </>
  );
}
